import {
  Directive,
  ElementRef,
  Renderer2,
  AfterViewInit,
  Input,
} from '@angular/core';

@Directive({
  selector: '[mwReadOnly],[readonly]',
})
export class MwReadOnlyDirective implements AfterViewInit {
  private isReadOnly = true;

  @Input()
  get mwReadOnly(): boolean {
    return this.isReadOnly;
  }
  set mwReadOnly(value: boolean) {
    this.isReadOnly = value === false ? false : true;
  }

  constructor(private _el: ElementRef, private _renderer: Renderer2) {}

  ngAfterViewInit(): void {
    if (this._el.nativeElement) {
      const el = this._el.nativeElement;
      if (this.isReadOnly) {
        this._renderer.setAttribute(el, 'readonly', 'true');
        if (el.parentNode && el.parentNode.parentNode) {
          const wrapper = el.parentNode.parentNode;
          if (wrapper.classList.contains('mat-form-field-flex')) {
            this._renderer.addClass(el.parentNode.parentNode, 'mw-readonly');
          }
        }
      }
    }
  }
}
